angular.module('skeyenoteWebApp').filter('sortByKey', sortByKey);

function sortByKey() {
  return function(properties) {
    let sortedKeys = properties ? Object.keys(properties) : [];
    return sortedKeys.sort();
  };
}
